import { Component, input } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { LucideAngularModule, Info } from 'lucide-angular';
import { LucideIconData } from 'node_modules/lucide-angular/icons/types';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [MatTooltipModule, LucideAngularModule],
})
export class TooltipComponent {
  readonly icon = input<LucideIconData>(Info);
  readonly tooltipText = input.required<string>();
  readonly position = input<TooltipPosition>('above');
  readonly disabled = input(false);
  readonly size = input<number>();
  readonly color = input<string>();
  readonly strokeWidth = input<number>();
  readonly absoluteStrokeWidth = input<boolean>();
  readonly isAction = input<boolean>();
}
